'use strict';

var App = require('app');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var ST = require('components/scheme/tools');

var AlterSchemeDialogView = Marionette.ItemView.extend({
    template: require('components/scheme/templates/edit_scheme'),

    ui: {
        toggleElementType: '.js-toggle-element-type',

        setpointDevice: '#js-device-select-0',
        targetDevice: '#js-device-select-1',
        actualValue: '#js-value-select-0',
        targetValue: '#js-value-select-1',
        visibility: '#js-toggle-visibility',

        text: '#js-text-value',

        save: '#js-save',
        delete: '#js-delete',
    },

    events: {
        'click @ui.toggleElementType': 'toggleElementType',

        'change @ui.setpointDevice, @ui.targetDevice': 'changeDevice',
        'changed.bs.select @ui.actualValue, @ui.targetValue': 'changeValue',
        'click @ui.visibility': 'toggleVisibility',

        'input @ui.text': 'changeText',

        'click @ui.save': 'save',
        'click @ui.delete': 'delete',
    },

    toggleElementType: function (e) {
        if (e.currentTarget.id == 'js-value' && this.elementType != ST.ElementTypes.VALUE) {
            this.elementType = ST.ElementTypes.VALUE;
        } else if (e.currentTarget.id == 'js-text' && this.elementType != ST.ElementTypes.TEXT) {
            this.elementType = ST.ElementTypes.TEXT;
        } else {
            e.stopPropagation();
        }
        e.preventDefault();

        this.updateButtonState();
    },

    initialize: function (options) {
        this.mode = options.isNewElement ? ST.Modes.ADD : ST.Modes.EDIT;
        this.elementType = options.type;

        this.dataRecords = this.initializeDataRecords(options.type == ST.ElementTypes.VALUE ? options.params : []);
        this.text = options.type == ST.ElementTypes.TEXT ? options.params[0] : '';

        this.isVisible = options.isVisible;
        this.loadValues();
    },

    initializeDataRecords: function (params) {
        var names = [i18n.TR('Anzeige bei Istwert'), i18n.TR('Anzeige bei Sollwert')];

        // new element? -> create two empty records
        if (params.length === 0) {
            params = [
                { deviceID: this.options.deviceID, address: undefined },
                { deviceID: this.options.deviceID, address: undefined },
            ];
        }
        return _.map(params, function (param, idx) {
            return {
                deviceID: param.deviceID,
                valueList: [],
                valueID: 0,
                name: names[idx],
                address: param.address,
                hasValues: false,
            };
        });
    },

    serializeData: function () {
        var data = {
            isCustomElement: this.options.isCustomElement,
            isVisible: this.isVisible,
            canDelete: this.options.isCustomElement && this.mode != ST.Modes.ADD,
            isNewElement: this.options.isNewElement,
            elementType: this.elementType,
            text: this.text,
            configValid:
                this.elementType === ST.ElementTypes.TEXT
                    ? this.text.length > 0
                    : _.reduce(
                          this.dataRecords,
                          function (configValid, record) {
                              return configValid || (record.valueID > 0 && record.deviceID > 0);
                          },
                          false
                      ),
        };
        data.valueConfig = {
            dataRecords: this.dataRecords,
            isVisible: this.isVisible,
        };
        data.editModes = [
            {
                id: 'js-value',
                title: i18n.TR('Neuen Wert hinzufügen'),
                active: this.elementType === ST.ElementTypes.VALUE,
                template: 'ADD_CUSTOM_VALUE',
                data: data.valueConfig,
            },
            {
                id: 'js-text',
                title: i18n.TR('Neuen Text hinzufügen'),
                active: this.elementType === ST.ElementTypes.TEXT,
                template: 'ADD_CUSTOM_TEXT',
            },
        ];

        return data;
    },

    onDomRefresh: function () {
        Misc.initSelectPicker();
        Misc.initDevicePicker();
    },

    loadValues: function (deviceID) {
        var modalDialog = $('.modal-content');
        Decorator.disableElement(modalDialog);

        var deviceIDs = deviceID
            ? [deviceID]
            : _.unique(
                  _.map(this.dataRecords, function (record) {
                      return record.deviceID;
                  })
              );

        var requests = _.map(deviceIDs, function (id) {
            return App.request('device:values', id);
        });

        var self = this;
        $.when.apply($, requests).done(function () {
            var lists = _.compact(arguments);
            if (lists.length === 0) {
                // request failed
                App.hideModal();
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Daten konnten nicht geladen werden.'));
                self.destroy();
            }

            // set the received value list to the data record with the same deviceID
            for (var listIdx = 0; listIdx < lists.length; listIdx++) {
                var l = lists[listIdx];
                l.models.splice(0, 0, { attributes: { id: -1, name: '-' } });
                for (var recIdx = 0; recIdx < self.dataRecords.length; recIdx++) {
                    if (self.dataRecords[recIdx].deviceID === l.deviceID) {
                        self.dataRecords[recIdx].valueList = l;
                        self.dataRecords[recIdx].hasValues = l && l.models && l.models.length > 0;
                    }
                }
            }

            Decorator.enableElement(modalDialog);
            self.initializeValues();
            self.render();
        });
    },

    initializeValues: function () {
        _.each(
            this.dataRecords,
            function (record) {
                var vID = record.valueList.findWhere({
                    type: this.getType(record.address),
                    nr: this.getNr(record.address),
                });
                record.valueID = vID ? vID.id : 0;
            },
            this
        );
    },

    getType: function (name) {
        return (name || '').split('_')[0];
    },

    getNr: function (name) {
        return parseInt((name || '').split('_')[1]);
    },

    changeDevice: function (e) {
        var recordIdx = e.currentTarget.id.split('-')[3];
        this.dataRecords[recordIdx].deviceID = $(e.currentTarget).val();
        this.loadValues(this.currentDeviceID);
        this.updateButtonState();
    },

    changeValue: function (e) {
        var recordIdx = e.currentTarget.id.split('-')[3];
        this.dataRecords[recordIdx].valueID = $(e.currentTarget).val();
        this.updateButtonState();
    },

    changeText: function (e) {
        this.text = e.currentTarget.value;
        this.updateButtonState();
    },

    save: function () {
        this.options.callbackParams.mode = this.mode;
        this.options.callbackParams.type = this.elementType;
        this.options.callbackParams.isVisible = this.isVisible;

        var payload = undefined;

        if (this.elementType === ST.ElementTypes.VALUE) {
            var self = this;
            payload = _.map(this.dataRecords, function (record) {
                var v = record.valueList.get(record.valueID);
                if (v === undefined) {
                    return 'undefined';
                }
                var device = record.deviceID == self.options.deviceID ? '' : '@' + record.deviceID;
                return v.get('type') + '_' + v.get('nr') + device;
            });
        } else {
            payload = [this.text];
        }

        this.options.save(payload, this.options.callbackParams);
    },

    delete: function () {
        this.options.callbackParams.isVisible = this.isVisible;
        this.options.callbackParams.mode = ST.Modes.DELETE;
        this.options.save(undefined, this.options.callbackParams);
    },

    toggleVisibility: function (e) {
        this.isVisible = $(e.currentTarget).prop('checked');
        this.updateButtonState();
    },

    updateButtonState: function () {
        this.ui.save.prop(
            'disabled',
            this.elementType === ST.ElementTypes.TEXT
                ? this.text.length == 0
                : !_.reduce(
                      this.dataRecords,
                      function (configValid, record) {
                          return configValid || (record.valueID > 0 && record.deviceID > 0);
                      },
                      false
                  )
        );
    },
});

module.exports = AlterSchemeDialogView;
